import {change} from "redux-form"
import {transformVehicle} from "./util/Validators";
import moment from "moment"
import mimetype from "mimetype-extension"

async function defaultFetch(url, data) {
    return await fetch(url, data);
}

export function EmptyHandler(url, brand,config, extensions, transform = (v) => {return v;}){
    {

        const ext = Object.assign({}, {
            onSubmit: async function (values, dispatch, props) {
            },
            onSubmitFail: async function (errors, dispatch, submitErrors, props) {
            },
            onSubmitSuccess: async function (results, dispatch, props) {
            },
            pre: {
                onSubmit: async function (values, dispatch, props) {
                },

            }
        }, extensions);
        return {
            onSubmit: async function (values, dispatch, props) {
                console.log({values});
                const obj = Object.assign({} , values);
                delete obj.video;
                const response = await fetch(url , {
                    method : "POST",
                    body : JSON.stringify(obj)
                })

                if(response.ok){
                    const json = await response.json();
                    const result = json.result;
                    console.log({json});
                    if (result.response.statusCode !== 500) {
                        return Object.assign({formValues: values}, result, (await ext.onSubmit(values, dispatch, props)));
                    } else {
                        dispatch(change(props.formName, 'upstreamerror', true));
                        throw new Error(JSON.stringify(result));
                    }
                }

            },
            onSubmitFail: async function (errors, dispatch, submitErrors, props) {
                return Object.assign({}, (await ext.onSubmitFail(errors, dispatch, submitErrors, props)));
            },
            onSubmitSuccess: async function (results, dispatch, props) {
                return Object.assign({}, (await ext.onSubmitSuccess(results, dispatch, props)));
            }
        }
    }

}

export default function (url, brand, config, extensions, fetchMethod = defaultFetch) {

    const ext = Object.assign({}, {
        onSubmit: async function (values, dispatch, props) {
        },
        onSubmitFail: async function (errors, dispatch, submitErrors, props) {
        },
        onSubmitSuccess: async function (results, dispatch, props) {
        },
        pre: {
            onSubmit: async function (values, dispatch, props) {
            },

        }
    }, extensions);
    return {
        onSubmit: async function (values, dispatch, props) {
            const data = Object.assign({}, brand, values);
            if (data.vehicle) {
                data.vehicle = config[transformVehicle(data.vehicle)].displayname;
            }
            await ext.pre.onSubmit(values, dispatch, props);
            const response = await fetchMethod(url, {
                method: "POST", body: JSON.stringify(data)
            });
            if (response.ok) {
                const json = await response.json();
                if (json.response.statusCode !== 500 && json.response.statusCode !== 403) {
                    return Object.assign({formValues: values}, json, (await ext.onSubmit(values, dispatch, props)));
                } else {
                    dispatch(change(props.formName, 'upstreamerror', true));

                    // see other error
                    // console.log('$$$$$$$$$1 ' + JSON.stringify(json.response.upstream.json[0].errorCode));
                    // dispatch(change(props.formName, 'upstreamerrormessage', json.response.upstream.json[0]));

                    dispatch(change(props.formName, 'upstreamerrormessage', json.response.upstream.request.body));
                    throw new Error(JSON.stringify(response));
                }
            } else {
                const json = await response.json();
                dispatch(change(props.formName, 'upstreamerror', true));
                dispatch(change(props.formName, 'upstreamerrormessage', json.response.upstream.request.body));
                throw new Error(JSON.stringify(response));
            }
        },
        onSubmitFail: async function (errors, dispatch, submitErrors, props) {
            console.log('errors:' + errors);
            console.log('submitErrors:' + submitErrors);
            return Object.assign({}, (await ext.onSubmitFail(errors, dispatch, submitErrors, props)));
        },
        onSubmitSuccess: async function (results, dispatch, props) {
            return Object.assign({}, (await ext.onSubmitSuccess(results, dispatch, props)));
        }
    }
}
